// extracted by mini-css-extract-plugin
export default {"article":"article--cmge9","table":"table--j4207"};